import React from 'react';
import { useTranslation } from 'react-i18next';
import { Body, Button, Modal } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';

type Props = {
  isOpen: boolean;
  handleClose: () => void;
};

const ProductNotReceivedModal: React.FC<Props> = ({ isOpen, handleClose }) => {
  const { t } = useTranslation('ihut');

  return (
    <Modal
      isOpen={isOpen}
      title={t('shippingInfo.productNotReceivedTitle')}
      closeButtonProps={{ UNSAFE_className: styles.closeBtn }}
      onClose={() => {}}
      actions={
        <Button
          variant="primary"
          size="medium"
          isFullWidth
          onClick={handleClose}
        >
          {t('close', { ns: 'common' })}
        </Button>
      }
    >
      <Body UNSAFE_style={{ whiteSpace: 'pre-line' }} size="large">
        {t('shippingInfo.productNotReceivedMessage')}
      </Body>
    </Modal>
  );
};

export default ProductNotReceivedModal;
